import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  id: yup.number().required(),
  patientId: yup.number().required(),
});

export function usePatientDocumentDeleteMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.delete(
        HTTP_ENDPOINTS.patientDocuments.delete({
          id: req.id,
          patientId: req.patientId,
        }),
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
